import Banner from "../../Components/SchoolPrograms/BannerSection/BannerSection";
import Blurbs from "../../Components/SchoolPrograms/Blurbs/Blurbs";
import ChoosePlans from "../../Components/SchoolPrograms/ChoosePlans/ChoosePlanss";
import Recess from "../../Components/SchoolPrograms/Recess/Recess";
import SkillsAndDrills from "../../Components/SchoolPrograms/SkillsAndDrills/SkillsAndDrills";
import SportsRecDay from "../../Components/SchoolPrograms/SportsRecDay/SportsRecDay";
import Advertisement from "../../Components/SchoolPrograms/Advertisement/Advertisement";
import "./style.css";
import SEO from "../../Components/SEO";
const SchoolPrograms = () => {
  return (
    <div className="program-contain">
      <SEO
        title="BWC Sports | School Programs"
        description=""
        url="https://bwcsports.com/school-programs"
      />
      <Banner />
      <Blurbs />
      <Recess />
      <ChoosePlans />
      <SportsRecDay />
      <SkillsAndDrills />
      <Advertisement />
    </div>
  );
};
export default SchoolPrograms;
